module.exports = __webpack_public_path__ + "static/img/ECOP_1@2x.86017566.png";